import moment from 'moment';
import { ACTIVATED, EXPIRED, INTRIAL } from 'constants/types';
import useAuth from './useAuth';

const getMessage = (endTrialPeriod) => {
  if (!endTrialPeriod) {
    return null;
  }

  if (moment(endTrialPeriod).isBefore(new Date(), 'day')) {
    return 'Seu período de avaliação terminou.';
  }

  if (moment(endTrialPeriod).isSame(new Date(), 'day')) {
    return 'Seu período de avaliação termina hoje.';
  }

  const period = moment
    .duration(moment(endTrialPeriod).diff(moment()))
    .humanize();

  return `Seu período de avaliação termina em ${period}.`;
};

const useSubscription = () => {
  const { subscription, isAdmin } = useAuth();
  const { features = [], endTrialPeriod } = subscription ?? {};

  const isTrial = subscription?.status === INTRIAL;
  const isExpired = subscription?.status === EXPIRED;
  const isActivated =
    isAdmin() || isTrial || subscription?.status === ACTIVATED;
  const expiresTrialMessage = isTrial ? getMessage(endTrialPeriod) : null;

  const hasFeature = (identifier) => {
    return features.findIndex((c) => c.identifier === identifier) >= 0;
  };

  const getValueFeature = (identifier, allowThrow = true) => {
    const feature = features.find((c) => c.identifier === identifier);

    if (!feature && allowThrow) {
      throw new Error('Feature não existe no plano');
    }

    return feature?.value;
  };

  return {
    subscription,
    hasLicense: subscription?.hasLicense ?? false,
    features,
    hasFeature,
    isActivated,
    isTrial,
    isExpired,
    expiresTrialMessage,
    getValueFeature
  };
};

export default useSubscription;
